var map = {
	"app/store/store.module.ngfactory": [
		"../../../../../src/aot/app/store/store.module.ngfactory.ts",
		"store.module"
	],
	"app/user/user.module.ngfactory": [
		"../../../../../src/aot/app/user/user.module.ngfactory.ts",
		"user.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/aot lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/aot lazy
// module id = ../../../../../src/aot lazy recursive
// module chunks = main